import { nativeScannerManufacturer } from '@ohf/core/shared';

/** Group display labels without changing a source catalogue value. */
export function scannerGroups(values: readonly string[], exclusiveValues: readonly string[], statusLabel: string, statusOptionLabel: (value: string) => string = value => value) {
  const groups = new Map<string, { value: string; label: string }[]>();
  const statuses: { value: string; label: string }[] = [];
  for (const value of values) {
    if (exclusiveValues.includes(value)) { statuses.push({ value, label: statusOptionLabel(value) }); continue; }
    // Source entries use a hyphen between manufacturer/model, sometimes without
    // the following space. Preserve product punctuation and the stored value.
    const separator = value.indexOf(' -');
    const manufacturer = nativeScannerManufacturer(value) ?? (separator < 0 ? value : value.slice(0, separator).trim());
    const label = separator < 0 && value.startsWith(`${manufacturer} `) ? value.slice(manufacturer.length).trim()
      : separator < 0 ? value : value.slice(separator + 2).trim();
    const options = groups.get(manufacturer) ?? [];
    options.push({ value, label }); groups.set(manufacturer, options);
  }
  const compare = (a: string, b: string) => a.localeCompare(b, 'en', { sensitivity: 'base', numeric: true });
  const result = [...groups].sort(([a], [b]) => compare(a, b)).map(([label, options]) => ({
    label, options: options.sort((a, b) => compare(a.label, b.label)),
  }));
  if (statuses.length) result.unshift({ label: statusLabel, options: statuses });
  return result;
}
